import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { BlogOrganisationTermsQuery } from '@custom/schema';

export const useBlogOrganisationTermsQuery = () =>
  useStaticQuery(graphql(BlogOrganisationTermsQuery));
